import { FC } from 'react'
import {
  default as MuiFormControlLabel,
  FormControlLabelProps as MuiFormControlLabelProps
} from '@mui/material/FormControlLabel'

export type FormControlLabelProps = MuiFormControlLabelProps

export const FormControlLabel: FC<FormControlLabelProps> = ({ ...props }) => (
  <MuiFormControlLabel {...props} />
)
